import { render, staticRenderFns } from "./ChannelsTable.vue?vue&type=template&id=cddb0a1a&scoped=true"
import script from "./ChannelsTable.vue?vue&type=script&lang=js"
export * from "./ChannelsTable.vue?vue&type=script&lang=js"
import style0 from "./ChannelsTable.vue?vue&type=style&index=0&id=cddb0a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddb0a1a",
  null
  
)

export default component.exports